import { default as Box } from '@mui/material/Box';
import { useFormikContext } from 'formik';
import { FormCard } from 'components/Card';
import { WarningCard } from 'components/notification-cards';
import { Text } from 'components/Text';
import { getTrans } from 'modules/i18n';
import { CVBuilderFormValues } from 'utils/cv-form-db';
import { PersonalDetailsFields } from './PersonalDetailsFields';

const BafoegWarning = () => (
  <WarningCard>
    <Text>
      {getTrans('cvBuilderPage.personalDetails.form.bafoeg.warning.title')}
    </Text>
    <Text variant="body2">
      {getTrans('cvBuilderPage.personalDetails.form.bafoeg.warning.body1')}
    </Text>
    <Text variant="body2">
      {getTrans('cvBuilderPage.personalDetails.form.bafoeg.warning.body2')}
    </Text>
    <Text variant="body2">
      {getTrans('cvBuilderPage.personalDetails.form.bafoeg.warning.body3')}
    </Text>
  </WarningCard>
);

const HoursInfoWarning = () => (
  <WarningCard sx={{ mb: 3 }}>
    <Text>
      {getTrans(
        'cvBuilderPage.personalDetails.form.hoursPerWeek.warning.title'
      )}
    </Text>
    <Text variant="body2">
      {getTrans(
        'cvBuilderPage.personalDetails.form.hoursPerWeek.warning.body1'
      )}
    </Text>
  </WarningCard>
);

export const PersonalDetailsForm = () => {
  const { values } = useFormikContext<CVBuilderFormValues>();

  const showHoursInfoWarning =
    !!values?.personalDetails.weeklyAvailableHours &&
    Number(values.personalDetails.weeklyAvailableHours) < 16;

  const showBafoegWarning = values?.personalDetails.stipendBafoeg === 'true';

  return (
    <FormCard>
      <PersonalDetailsFields />
      {showHoursInfoWarning && <HoursInfoWarning />}
      {showBafoegWarning && (
        <>
          <Box sx={{ pb: 2 }} />
          <BafoegWarning />
        </>
      )}
    </FormCard>
  );
};
